import {pageInfo,getDeviceGroupAttribute,getDeviceGroupDetail,updateDeviceGroupAttributeValue} from './../api';
import {Message} from 'element-ui';
import {plant} from "../../../../api";

const interfaceLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
    attributeGroupPageResp:null,
    detailGroupPageResp:null,
    elseTotal:0,
    plantAreaObj: [],
    exportObj: [],
    updateDeviceGroupAttributeValueObj:null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    GET_DEVICE_GROUP_ATTRIBUTE(state, data) {
      state.attributeGroupPageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    GET_DEVICE_GROUP_DETAIL(state, data) {
      state.detailGroupPageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    UPDATE_DEVICE_GROUP_ATTRIBUTE_VALUE(state, data) {
      state.updateDeviceGroupAttributeValueObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async getDeviceGroupAttribute({commit}, obj) {
      let resp = await getDeviceGroupAttribute(obj);
      commit('GET_DEVICE_GROUP_ATTRIBUTE', resp);
    },
    async getDeviceGroupDetail({commit}, obj) {
      let resp = await getDeviceGroupDetail(obj);
      commit('GET_DEVICE_GROUP_DETAIL', resp);
    },
    async updateDeviceGroupAttributeValue({commit}, obj) {
      let resp = await updateDeviceGroupAttributeValue(obj);
      commit('UPDATE_DEVICE_GROUP_ATTRIBUTE_VALUE', resp);
    },

  }
}
export default interfaceLog



// WEBPACK FOOTER //
// ./src/page/md/deviceGroup/store/deviceGroup.store.js